export default function (link, picName) {
  const xhr = new XMLHttpRequest();
  xhr.open("get", link, true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    const url = URL.createObjectURL(xhr.response);
    const a = document.createElement("a");
    const event = new MouseEvent("click");
    a.href = link;
    a.download = picName || "default.png";
    a.dispatchEvent(event);
    URL.revokeObjectURL(url);
  };
  xhr.send();
}